import pd from 'platform-detect';

export const IS_WINDOWS = pd.windows;
export const IS_IOS = pd.ios;
export const IS_ANDROID = pd.android;
export const IS_MACOS = pd.macos;
export const IS_CHROMEOS = pd.chromeos;

export const IS_CHROME = pd.chrome;
export const IS_EDGE = pd.edge;
export const IS_FIREFOX = pd.firefox;
export const IS_SAFARI = pd.safari;
export const IS_LINUX = pd.linux
export const HAS_WEBXR = false//window.navigator.xr ? true : false
export const IS_DESKTOP = pd.formfactor === "desktop" || pd.formfactor === "hybrid"
export const IS_MOBILE = pd.formfactor === "phone"
export const IS_TABLET = pd.formfactor === "tablet"
export const IS_IPAD = (navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2) === true ? true : false;
export const IS_BRYJ_KIOSK = navigator.userAgent.includes("Bryj-Kiosk");
if (IS_BRYJ_KIOSK) {
    console.log('[Bitreel] Bryj-Kiosk device detected - WebXR and device orientation disabled');
}
